import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhoWeAre from './components/WhoWeAre';
import MissionVision from './components/MissionVision';
import Goal from './components/Goal';
import LandingFocusAreas from './components/LandingFocusAreas';
import LandingImpact from './components/LandingImpact';
import GetInvolved from './components/GetInvolved';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ImpactPage from './pages/ImpactPage';
import ObjectivesPage from './pages/ObjectivesPage';
import ContactPage from './pages/ContactPage';

function HomePage() {
  return (
    <>
      <Hero />
      <WhoWeAre />
      <MissionVision />
      <Goal />
      <LandingFocusAreas />
      <LandingImpact />
      <GetInvolved />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/impact" element={<ImpactPage />} />
          <Route path="/objectives" element={<ObjectivesPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
